import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alertModule';
import { authentication } from './authenticationModule';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        alert,
        authentication,
    }
});

export default store;
